import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Link from '~/src/components/link/Link';
import Image from '~/src/components/image/Image';
import NavLifestyle from '~/src/components/svg/navigation/NavLifestyle';

import {TeaserFormat, ImageFormat} from '~/src/utilities/constants/formats';
import {ImageSize} from '~/src/utilities/constants/image';
import {classNames} from '~/src/utilities/helpers/css';
import {SiteArea} from '~/src/utilities/constants/navigation';
import {withSettingsContext} from '~/src/components/context/SettingsContext';

import css from './CrassAd.module.scss';

const CrassAd = (props) => {
    const isLifestyleCrassAd = props.teaserType === 'lifestyle';
    const siteArea = get(props, 'context.settings.siteArea', SiteArea.NEWS);

    const className = classNames(css, 'crassAd', props.format, props.colorScheme, siteArea, {isLifestyleCrassAd});

    const imageSizes = props.format === TeaserFormat.TEASER_LARGE ? ImageSize.TEASER_LARGE : ImageSize.TEASER_SMALL;

    const image = {
        variants: {
            small: {
                src: props.image
            }
        }
    };

    return (
        <Link className={className} href={props.clickThroughUrl}>
            <div className={css.media}>
                <div className={css.imgContainer}>
                    <Image {...image} format={ImageFormat.IMAGE_COVER} sizes={imageSizes} />
                </div>
                {props.kickwordText && (
                    <h3 className={css.kickword} style={{backgroundColor: props.kickwordColor}}>
                        {props.kickwordText}
                    </h3>
                )}
            </div>
            <section className={css.content}>
                <h2 className={css.titleHeader}>
                    {isLifestyleCrassAd && siteArea !== SiteArea.LIFESTYLE && <NavLifestyle />}
                    {props.customHeaderText}
                </h2>
                <h1 className={css.title}>{props.title}</h1>
                <p className={css.lead}>{props.text}</p>
            </section>
        </Link>
    );
};

if (process.env.NODE_ENV === 'development') {
    CrassAd.propTypes = {
        clickThroughUrl: PropTypes.string,
        customHeaderText: PropTypes.string,
        title: PropTypes.string,
        text: PropTypes.string,
        image: PropTypes.string,
        kickwordColor: PropTypes.string,
        kickwordText: PropTypes.string,
        teaserType: PropTypes.string
    };
}

export default withSettingsContext(CrassAd);
